import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { Suspense } from 'react'
import { SubscriptionsBreadcrumb } from '../SubscriptionBreadcrumbs'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { OrgUserForm } from '../Forms/OrgUserForm'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCurrentOrganisation } from '../useCurrentOrganisation'
import { columns } from './OrganisationUsersTable/organisationUsersTableColumns'

export function OrganisationUsersPage() {
  return (
    <>
      <SubscriptionsBreadcrumb title="Users" />
      <QueryErrorBoundary errorMessage="Failed to fetch organisation">
        <Suspense fallback={<LoadingComponent className="flex-1" />}>
          <OrganisationUsersPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function OrganisationUsersPanelContent() {
  const { id: orgId } = useCurrentOrganisation()
  const { getSubscriptionsApiListOrganisationUsers } = useRestClient()

  const { data: organisationUsers } = getSubscriptionsApiListOrganisationUsers.useSuspenseQuery({
    query: {
      orgId,
    },
  })
  return (
    <TablePageContainer>
      <DataTable
        columns={columns}
        data={organisationUsers}
        action={
          <OrgUserForm
            sheetTitle="Add a user"
            sheetTrigger={
              <Button size="lg" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add user
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
